import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { LoginModal } from "@/components/auth/LoginModal";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { MobileNav } from "@/components/layout/MobileNav";
import { PushOptInToast } from "@/components/notifications/PushOptInToast";
import { ProfileVisitToast } from "@/components/profile/ProfileVisitToast";
import { useFriendStatusVisibilitySync } from "@/hooks/use-friend-status-visibility-sync";
import { useProfileVisits } from "@/hooks/use-profile-visits";
import { usePushNotifications } from "@/hooks/use-push-notifications";
import { useTimeSync } from "@/hooks/use-time-sync";
import { hasUserCookie } from "@/lib/auth-cookie";
import { ensureSessionMarker } from "@/lib/session-probe";
import { useAuthStore } from "@/stores/auth-store";

export const Route = createFileRoute("/_app")({
	beforeLoad: async ({ context, location }) => {
		// Fehlt der Marker, kann trotzdem eine gültige Backend-Session bestehen —
		// erst klären, dann entscheiden. Der Roundtrip ist hier gerechtfertigt,
		// weil der Marker unmittelbar über einen Redirect entscheidet.
		await ensureSessionMarker(context.queryClient);

		if (!hasUserCookie()) {
			throw redirect({
				to: "/login",
				search: { redirect: location.href },
			});
		}
	},
	component: AppLayout,
});

function AppLayout() {
	useTimeSync();
	useFriendStatusVisibilitySync();
	const showLoginModal = useAuthStore((s) => s.showLoginModal);
	const setShowLoginModal = useAuthStore((s) => s.setShowLoginModal);
	const { notification, dismissNotification, handleAction } = useProfileVisits();
	const { showOptIn, activate, dismiss } = usePushNotifications();

	return (
		<div className="min-h-screen bg-background flex flex-col">
			<Header />
			<main className="flex-1 w-full max-w-7xl mx-auto px-4 py-6 pb-24 lg:pb-6">
				<Outlet />
			</main>
			<Footer />
			<MobileNav />
			<LoginModal open={showLoginModal} onClose={() => setShowLoginModal(false)} />
			{notification && (
				<ProfileVisitToast
					notification={notification}
					onDismiss={dismissNotification}
					onAction={handleAction}
				/>
			)}
			{showOptIn && <PushOptInToast onAccept={activate} onDismiss={dismiss} />}
		</div>
	);
}
